import { createBroadcastProducer } from '@highlight/ipc'
import {
  TRANSCRIPT_PARTIALS_TOPIC,
  type PartialTranscription,
  type TranscriptPartialMessage,
  type TranscriptPartialSource,
} from '@shared/transcript-feed'

type PartialsProducer = ReturnType<typeof createBroadcastProducer<TranscriptPartialMessage>>

// Lazy-registered so idle copies of the transcription service singleton
// (e.g. the overlay's in Electron, which never produces) don't allocate
// ghost producer ports in the broker.
let producer: PartialsProducer | null = null

/** Publish a partial-transcript line (or `null` to clear it) to whichever
 *  renderers are currently displaying partials. No subscribers, no IPC. */
export function publishPartialTranscription(
  source: TranscriptPartialSource,
  partial: PartialTranscription | null,
): void {
  if (!producer) {
    producer = createBroadcastProducer<TranscriptPartialMessage>(TRANSCRIPT_PARTIALS_TOPIC)
  }
  producer.publish({ source, partial })
}
